import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { Box, Typography, Fade } from '@material-ui/core';
import { TextColor } from '@setvi/shared/enums';
import { useRotatingMessages } from 'hooksv2';
import { useState, useEffect } from 'react';
import { SButton } from '@setvi/shared/components';

export interface AILoaderProps {
  messages: string[];
  showCancelButton?: boolean;
  onCancelClick?: () => void;
  messageTextFontSize?: number;
}

export const AILoader = ({
  messages,
  showCancelButton = false,
  messageTextFontSize = 14,
  onCancelClick
}: AILoaderProps) => {
  const rotMessages = useRotatingMessages(messages, { delay: 5000 });

  // Used to trigger the fade animation
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    setVisible(false);
    const timeout = setTimeout(() => setVisible(true), 100); // brief hide before fade in
    return () => clearTimeout(timeout);
  }, [rotMessages]);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      style={{ color: TextColor.Main }}
      margin="auto"
      gridGap={16}>
      <Box width={150} height={150}>
        <DotLottieReact
          loop
          autoplay
          src="/images/lottie/loading-star.lottie"
          style={{ width: '100%', height: '100%' }}
        />
      </Box>

      <Fade in={visible} timeout={500} key={rotMessages}>
        <Typography
          style={{
            transition: 'opacity 0.3s ease-in-out',
            textAlign: 'center',
            fontSize: messageTextFontSize,
            color: TextColor.Main
          }}>
          {rotMessages}
        </Typography>
      </Fade>

      {showCancelButton && (
        <SButton
          variant="text"
          style={{
            color: TextColor.SlateGrey,
            textDecoration: 'underline'
          }}
          onClick={onCancelClick}>
          Cancel
        </SButton>
      )}
    </Box>
  );
};
